module.exports = __webpack_public_path__ + "img/m_bereza.ed3f304a.png";